import Image from 'next/image';

export const socialMediaLinks = [
  {
    icon: <Image src="/assets/svg/bale.svg" alt="بله" width={18} height={18} />,
    link: 'https://ble.ir/witro',
  },
  {
    icon: (
      <Image src="/assets/svg/aparat.svg" alt="آپارات" width={22} height={22} />
    ),
    link: 'https://www.aparat.com/Witro.Shop',
  },
  {
    icon: (
      <Image
        src="/assets/svg/youtube.svg"
        alt="یوتیوب"
        width={22}
        height={22}
      />
    ),
    link: 'https://www.youtube.com/channel/UCyq-kdyPSiNRsgyyOX1yIQw',
  },
  {
    icon: (
      <Image
        src="/assets/svg/linkedin.svg"
        alt="لینکدین"
        width={22}
        height={22}
      />
    ),
    link: 'https://www.linkedin.com/company/naqshava',
  },
  {
    icon: (
      <Image
        src="/assets/svg/instagram.svg"
        alt="اینستاگرام"
        width={22}
        height={22}
      />
    ),
    link: 'https://instagram.com/witro.shop',
  },
];

const witroMagUrl =
  process.env.NEXT_PUBLIC_WITRO_MAG || 'https://mag.witro.shop';

export const resources = [
  {
    text: 'نمونه فروشگاه‌ها',
    link: '/store-examples',
  },
  {
    text: 'امکانات ویترو',
    link: '/features',
  },
  {
    text: 'سوالات متداول',
    link: '/#faq',
  },
  {
    text: 'وبلاگ',
    link: witroMagUrl,
  },
  {
    text: 'ارتباط با ما',
    link: '/contact',
  },
  // {
  //   text: 'حریم خصوصی',
  //   link: '/privacy',
  // },
  {
    text: 'قوانین و مقررات',
    link: '/privacy-policies',
  },
];

const witroCdn = process.env.WITRO_CDN_URL || 'https://cdn.witro.shop';

export const licenses = [
  {
    icon: `${witroCdn}/static/images/svg/khalagh-logo.svg`,
    link: '',
    alt: 'innovative-enterprises',
  },
  {
    icon: `${witroCdn}/static/images/svg/irannsr.svg`,
    link: 'http://tehran.irannsr.org/index.php?module=web_directory&wd_id=104366&ctp_id=1086&id=46409',
    alt: 'guild-system',
  },
];
